import useAppContext from './useAppContext';
import useIsB2BUser from './useIsB2BUser';

// The Full pendulum logo is a B2B-only look, except for an admin who is
// impersonating an artist (the token carries an `actor` claim). The API
// applies the same rule, so this only decides whether the controls show.
const useCanSetFullLogo = (): boolean => {
  const { impersonationActor } = useAppContext();
  const isB2BUser = useIsB2BUser();

  return isB2BUser || Boolean(impersonationActor);
};

export default useCanSetFullLogo;
